import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';

export const StyledButton = styled.button<{ $disabled?: boolean }>`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.25rem;
  background-color: ${({ theme, $disabled }) =>
    $disabled ? theme.color.betaBadgeBG : (theme as IOcAppTheme).color.askHumanButtonBg || '#f58026'};
  color: white;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  font-size: ${({ theme }) => theme.font.size.default};
  transition: opacity 0.2s;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  &:hover {
    opacity: ${({ $disabled }) => ($disabled ? 0.6 : 0.9)};
  }
`;

